import React, { Component } from 'react'

import '../../css/BisharatMain.css';
import translate from '../../languages/translate';


export default class ActivationError extends Component {


  render() {

    return (
        <div className="activate-user-wrap">
            <h1>{translate("not-activated")} </h1>
    </div>
    )
  }
}
